/**
* Sticky element
**/

;(function ($, window, _) { // eslint-disable-line no-extra-semi
    'use strict';

    /**
     * Focus component constructor
     * @param $element
     * @param target
     */
    var Sticky = function ($element, options) {
        this._$el = $element;
        this._options = $.extend(false, Sticky.config, options);
        this.dataObj= getData(this._options.positions);
        
        //console.log(this.dataObj);
        this._init();
    };
    
    /*
     * Default settings
     */
    Sticky.config = {
        classes: {
            start: 'set--start',
            end: 'set--end',
            fixed: 'set--fixed'
        }  
    };

    Sticky.prototype._init = function() {
        var self =this;

        //console.log(self.dataObj);
        //Bind scroll to data object
        $(window).bind('scroll',function() {

            $.each(self.dataObj, function(index) {
                
                var window_top = $(window).scrollTop();
            
                if (window_top > this[0] && window_top < this[1]) {
                    
                    self._$el
                        .removeClass(self._options.classes.start)
                        .removeClass(self._options.classes.end)
                        .addClass(self._options.classes.fixed);

                } else if (window_top >= this[1]) {
                    self._$el
                        .removeClass(self._options.classes.fixed)
                        .addClass(self._options.classes.end);

                } else if (window_top < this[0]) {
                    self._$el
                        .removeClass(self._options.classes.fixed)
                        .addClass(self._options.classes.start);
                }
           });
        });

        //Load New data when screen resize
        $(window).resize(function() {
	        if(this.resizeTO) 
	    	    clearTimeout(this.resizeTO);
	    
            this.resizeTO = setTimeout(function() {
	            $(this).trigger('resizeEnd');
            }, 500);
        });
		
		$(window).bind('resizeEnd', function() {
            self.dataObj= getData(self._options.positions);
		});
    }

    var getData = function(data) {
        var itemArray=[],
            top = 0,
            bottom = 0;

            top = data.start.bottom ? $(data.start.top).offset().top + $(data.start.top).outerHeight() : $(data.start.top).offset().top;
            bottom = data.end.bottom ? top + $(data.end.bottom).outerHeight() : $(data.end.top).offset().top;

            itemArray.push([top,bottom]);

		return itemArray;
    };

     /**
     * Attach new focus
     * @private
     */
    Sticky.prototype._attach = function () {
        var $el = $(this),
            options = $el.data('sticky') ? $el.data('sticky') : {},
            positions = {};
        
        positions.start = $el.data('sticky-start');
        positions.end =   $el.data('sticky-end');
        
        options.positions = positions;
        //console.log(options, $el);
        new Sticky($el, options);
    };


    /**
     * Attach listeners to document
     */
    $(function () {
        /**
         * Travel through the DOM for data-focus attributes
         */
        //$('[data-stricky]').each(Sticky.prototype._attach);

        /**
         * Setup a jQuery chainable plugin for attaching to injected elements after page load
         * @type {*}
         */

        $.fn.jqStricky = function () {
            $(this).each(Sticky.prototype._attach);
        };

    });

})(jQuery, window, _);

